module.exports = __webpack_public_path__ + "static/media/similMaderaCerejeira.769f15a8.jpg";